import BaseModel from "lib/model";
import BaseCollection from "lib/collection";

const AvailableInventory = BaseModel.extend({
    props: {
        display_quantity: { type: "string", required: true },
        available: { type: "number", required: false },
    },
});

const Replenishment = BaseModel.extend({
    props: {
        id: "objectId",
        brand: { type: "objectId", required: true },
        sku_id: { type: "objectId", required: true },
        warehouse_id: { type: "objectId", required: true },
        display_name: { type: "string", required: true },
        period_start: { type: "utcDate", required: true },
        period_end: { type: "utcDate", required: false },
        prebook: { type: "boolean", required: true, default: false },
        active: { type: "boolean", required: true, default: true },
        quantity: { type: "number", required: true },
        display_quantity: { type: "string", required: true },
    },
    children: {
        available: AvailableInventory,
    },
});

const Replenishments = BaseCollection.extend({
    model: Replenishment,
    mainIndex: "sku_id",
});

export default BaseModel.extend({
    props: {
        period_start: { type: "utcDate", required: true },
    },
    collections: {
        replenishments: Replenishments,
    },
});
